import { jsxs as c, jsx as r } from "react/jsx-runtime";
import { ConditionalLink as l } from "../../../../../../components/ConditionalLink/index.js";
import { Author as i } from "../../../../style.js";
import { Timestamp as s } from "./style.js";
import { useTranslation as p } from "../../../../../../hooks/useTranslation/index.js";
const j = ({
  author: e,
  profileURL: o,
  formattedTime: t,
  isDeleted: m,
  isAuthorVerified: n
}) => {
  const { t: d } = p("common");
  return /* @__PURE__ */ c("div", { children: [
    /* @__PURE__ */ r(l, { url: o, title: e, children: m ? /* @__PURE__ */ r(i, { children: d("parent-comment-header") }) : /* @__PURE__ */ r(i, { isVerified: n, children: `@${e}` }) }),
    /* @__PURE__ */ r(s, { children: t })
  ] });
};
export {
  j as ParentCommentHeader
};
